import axios from 'axios'

// const BASE_URL = 'http://localhost:5354/'

let BASE_URL = '//imeicheck.pro/api/'

if (window.location.hostname.includes("mate")){
  BASE_URL = '//imeimate.com/api/'
}

if (window.location.hostname.includes("fit")){
  BASE_URL = '//imei.fit/api/'
}

if (window.location.hostname.includes("unlockhost")){
  BASE_URL = '//unlockhost.com/api/'
}

BASE_URL = window.location.protocol + BASE_URL

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: false,
  params: {} // do not remove this, its added to add params later in the config
})

// Add a request interceptor
instance.interceptors.request.use(function (config) {
  /* global window Store */
  const {token} = Store.state.user
  // console.log("token", token)
  if (token) {
    config.headers.common['Authorization'] = 'Bearer ' + token
    config.headers.common['Access-Control-Allow-Origin'] = '*'
  } else {
    // Use application/x-www-form-urlencoded for login
    config.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
    config.headers.common['AppVer'] = '1.7'
  }

  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

instance.interceptors.response.use((response) => response, (error) => {
  // console.log(error.config)
  return Promise.reject(error)
})

export default {
  getData (action) {
    let url = `${BASE_URL}`
    url += action
    return instance.get(url)
  },
  getDataByURL (url) {
    return instance.get(url)
  },
  postData (action, data) {
    let url = `${BASE_URL}`
    url += action
    return instance.post(url, data)
  },
  postDataByURL (url, data) {
    return instance.post(url, data)
  },
  putData (action, data) {
    let url = `${BASE_URL}`
    url += action
    return instance.put(url, data)
  },
  deleteData (action) {
    let url = `${BASE_URL}`
    url += action
    return instance.delete(url)
  },
  login (action, data) {
    let url = `${BASE_URL}`
    url += action
    return instance.post(url, data)
  },
  logout () {
    let url = `${BASE_URL}`
    url += "logout.php"
    return instance.get(url)
  }
}



// WEBPACK FOOTER //
// ./src/utils/backend-api.js